/*
 * Alhena "Virtual Concierge" teaser — held on phones.
 *
 * The bubble pops about five seconds after load and lands on the size picker
 * and the sticky Add to Cart bar. Hold it (the launcher icon stays) until the
 * shopper has been idle for 30 seconds or has scrolled past the reviews, and
 * keep holding it whenever it would sit over the variant picker, the Add to
 * Cart button or the sticky bar. hi-chat-teaser.css does the hiding.
 */
(function () {
  if (!window.matchMedia('(max-width: 767px)').matches) return;

  var root = document.documentElement;
  var HELD_CLASS = 'is-chat-teaser-held';
  var IDLE_MS = 30000;
  // Measured at 85px; headroom for a two-line message.
  var TEASER_HEIGHT = 110;
  var GUARDED =
    '.shopify-section[id$="__main"] [data-product-variants],' +
    '.shopify-section[id$="__main"] [data-add-to-cart],' +
    '#cart-bar';

  var released = false;
  var idleTimer = null;
  var frame = null;

  root.classList.add(HELD_CLASS);

  // The bubble renders directly above the launcher, left-aligned with it.
  function teaserZone() {
    var launcher = document.querySelector('#helix-chat-container [role="button"][aria-label*="chat" i]');
    var rect = launcher && launcher.getBoundingClientRect();
    if (rect && rect.height > 0) {
      return { top: rect.top - TEASER_HEIGHT, bottom: rect.top, left: rect.left, right: rect.left + 290 };
    }
    return { top: window.innerHeight - 200, bottom: window.innerHeight, left: 0, right: 300 };
  }

  function overlapsBuyBox() {
    var zone = teaserZone();
    var guarded = document.querySelectorAll(GUARDED);
    for (var i = 0; i < guarded.length; i++) {
      var r = guarded[i].getBoundingClientRect();
      if (r.width && r.height && r.top < zone.bottom && r.bottom > zone.top && r.left < zone.right && r.right > zone.left) {
        return true;
      }
    }
    return false;
  }

  function pastReviews() {
    var reviews = document.querySelector('.kl_reviews__reviews_list');
    if (!reviews) return false;
    return (reviews.closest('.shopify-section') || reviews).getBoundingClientRect().bottom < 0;
  }

  function update() {
    frame = null;
    if (!released && pastReviews()) released = true;
    root.classList.toggle(HELD_CLASS, !released || overlapsBuyBox());
  }

  function schedule() {
    if (frame === null) frame = window.requestAnimationFrame(update);
  }

  function restartIdleTimer() {
    clearTimeout(idleTimer);
    idleTimer = setTimeout(function () {
      released = true;
      update();
    }, IDLE_MS);
  }

  ['touchstart', 'click', 'keydown'].forEach(function (type) {
    document.addEventListener(type, restartIdleTimer, { passive: true });
  });
  window.addEventListener('scroll', function () {
    restartIdleTimer();
    schedule();
  }, { passive: true });
  window.addEventListener('resize', schedule);
  restartIdleTimer();
})();
